// Mirrors msm-backend Mismatch.Domain.Stats.Enums.ForfeitReason (serialized as strings).
const FORFEIT_REASONS = {
  STANDARD: 'StandardForfeit',
  LESS_THAN_2_PLAYERS: 'LessThan2Players',
}

export default FORFEIT_REASONS
